import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { VerificationCode } from '@components/verify-phone-modal/data-access/models/verify-phone-modal.model';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VerifyPhoneApi {
  readonly #http = inject(HttpClient);

  postVerifyPhone$(verificationCode: VerificationCode) {
    return this.#http.post<void>(`${environment.protocol}${environment.webApiUrl}/user/verify-phone`, {
      verificationCode
    });
  }

  postVerifyPhoneResend$(language: string, eventId: number = null) {
    return this.#http.post<void>(`${environment.protocol}${environment.webApiUrl}/user/verify-phone-resend`, {
      language,
      eventId
    });
  }
}
